import { TaskHeader } from '@scale/scaleui';
import { FC, useContext } from 'react';
import { ShortcutsContext } from 'react-scale/hooks/useShortcut';
import { ShortcutType } from '@scale/shared/types/preference';
import { renderTrigger } from 'react-scale/components/scalers/tasks/common/Shortcuts/defaults';

type IconTriggerAutosaveProps = {
  autosaveEnabled: boolean;
  isAutosaving?: boolean;
  triggerAutosave: () => void;
  visible?: boolean;
};
export const IconTriggerAutosave: FC<IconTriggerAutosaveProps> = ({
  isAutosaving,
  triggerAutosave,
  autosaveEnabled,
  visible,
}) => {
  const { getTrigger } = useContext(ShortcutsContext);
  const autosaveTrigger = getTrigger(ShortcutType.Autosave);
  if (!autosaveEnabled) return null;
  const tooltip = (
    <p>Click to save progress now {autosaveTrigger && renderTrigger(autosaveTrigger)}</p>
  );
  return (
    <TaskHeader.IconHandlerItem
      visible={visible}
      icon={['far', 'sync-alt']}
      onClick={triggerAutosave}
      disabled={isAutosaving}
      label="Autosave"
      tooltip={tooltip}
    />
  );
};
